module.exports = new __parcel__URL__("add-link.bb1e704f.svg").toString();